export const environment = {
    production: false,
    productName: "Altius",
    errMsg: 'Failed to complete. Please try again.',
    partner: false,
    multiregion: true,
    regions: [{
        regionId: "1",
        regionCode: "NA",
    },{
        regionId: "2",
        regionCode: "EU",
    }],
    config: {
        "haystackUrl": "https://silo.qa.service.75f.io/",
        "auth": {
            "caretakerUrl": "https://caretaker.qa.service.75f.io/api/v1"
        },
        
        "edgeRunnerApi": "https://micropython-edge-api.azurewebsites.net/",
        'devCycleClientId':"dvc_client_6a871843_2d50_4cd3_8085_838c6ef552ea_54fce3b",
        "externalServices": "https://external-services.qa.service.75f.io/",
        "userTractionUrl": "https://user-traction.qa.service.75f.io/",
        "helpCenter": "https://support.75f.io",
        "partnerName": "75F",
        "klipyApiKey": 'chJg8W90GkVk6F4D0hic2iJA3IKcyN2ihgHjqNEA3LMLXG6CL6GhwkZ3FExFBa3u',
        "1":{
            "regionName": "North America",
            "haystackUrl": "https://silo.qa.service.75f.io/",
            "siteSequencerUrl": "https://seq-runner.qa.service.75f.io",
            "notesUrl": "https://notes-api.qa.service.75f.io/",
            "filestorageUrl": "https://filestorage.qa.service.75f.io/",
            "equipBuilderUrl": "https://equip-builder-75f-qa-service-eastus-g9fsfybkdzfvc4b7.eastus-01.azurewebsites.net/",
        },
        "2":{
            "regionName": "Europe",
            "haystackUrl": "https://silo.qa-eu.service.75f.io/",
            "siteSequencerUrl": "https://seq-runner.qa-eu.service.75f.io",
            "notesUrl": "https://notes-api.qa-eu.service.75f.io/",
            "filestorageUrl": "https://filestorage.qa-eu.service.75f.io/",
            "equipBuilderUrl": "https://equip-builder-75f-qa-service-westeu-dufge9hkccfgaecu.westeurope-01.azurewebsites.net/",
        }
    }
};
